import React from "react";
import styles from "./event-description-modal.module.css";
import { useDispatch, useSelector } from "react-redux";
import { inactive } from "../../../store/reducers/toggle/scheduleModalToggle";
import { v4 } from "uuid";

import StandardRewardRow from "../../journey/standard-reward-row";
import EventDescription from "./event-description";
import WeatherDescription from "./weather-description";
import ArcanaDescription from "./arcana-description";

export default function EventDescriptionModal({ lang, selected, setSelected }) {
    // if (!modalToggle.selected || modalToggle.selected === "아르카나") {
    //     return;
    // }

    // modalToggle.selected === 아르카나
    // load selected deck's arcana list
    // select box list = arcana list
    // show arcana events
    return (
        <div
            className={`modal scroll ${selected ? "active" : ""} event-desc`}
            onClick={(e) => {
                if (e.target.classList.contains("modal")) {
                    setSelected(null);
                }
            }}
        >
            <div className="window">
                <button className="close-button" onClick={() => setSelected(null)}>
                    <i className="fi fi-sr-x" />
                </button>
                {selected && typeof selected.content === "object" && (
                    <EventDescription lang={lang} selected={selected.content} desc={selected.desc} />
                )}
                {selected && selected.content === "날씨" && <WeatherDescription lang={lang} desc={selected.desc} />}
                {selected && selected.content === "아르카나 이벤트" && <ArcanaDescription lang={lang} desc={selected.desc} />}
            </div>
        </div>
    );
}
